import React, { useEffect } from "react";
import { makeStyles, Typography, Grid, Button } from "@material-ui/core/";
import { useDispatch, useSelector } from "react-redux";
import { getClassData } from "../../../../reduxSlices/classesSlice";
import localizedStrings from "../../../../utils/localize";
const useStyle = makeStyles((theme) => ({
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
}));
const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Grid className={classes.classConatiner}>
      <Typography component="div" className={classes.classFont}>
        {localizedStrings.students.classes.classes}
      </Typography>
      <Typography component="div">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }}
        >
          {localizedStrings.students.classes.refresh}
        </Button>
      </Typography>
    </Grid>
  );
};

export default TopItems;
